export default __webpack_public_path__ + "static/media/publicTransport.9fe703d6.svg";